import React from "react";
import HOC from "../../../components/HOC";
import TransferList from "../../../components/screen/centralWarehouse/transfer/TransferList";
import PageTemplate from "../../../components/common/particles.jsx/PageTemplate";
import { ThemeProvider } from "@mui/material";
import { theme } from "../../../components/constants/muiTheme";

const TransferListPage = () => {
  return (
    <div className="">
      <PageTemplate
        header="Transfer"
        mainComponent={
          <ThemeProvider theme={theme}>
            <TransferList />
          </ThemeProvider>
        }
        pageRole={35}
        noPadding={true}
      />
    </div>
  );
};

export default HOC(TransferListPage);
